const generateRandomRph = () => Math.floor(Math.random() * 10000)

export default generateRandomRph
